import script from "./transfer.vue?vue&type=script&lang=ts&setup=true"
export * from "./transfer.vue?vue&type=script&lang=ts&setup=true"

import "./transfer.vue?vue&type=style&index=0&id=64051b39&lang=scss"
import "./transfer.vue?vue&type=style&index=1&id=64051b39&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64051b39"]])

export default __exports__